export const InvoiceFooter = () => {
  const contact = "HOT LINE: 09642222555 | info@jananiexpress.com";
  return (
    <div>

      <p className="text-black font-bold text-sm px-4 py-3 mx-6 mb-8 bg-gray-100 border border-gray-400 rounded">
        <span className="font-bold">নোট: </span>
        এই চাহিদা মালামাল হাতে পাওয়ার সাথে সাথে ম্যানেজারের স্বাক্ষর এবং শাখার সিল দিয়ে হিসাব শাখায় (আইটি সেকশন) বরাবর এক কপি পাঠিয়ে দিবেন।
      </p>
      {/* Signatures */}
      <div className="grid grid-cols-5 gap-8 px-6 pt-16 pb-8 text-center mt-3">

         <div>
          
          
          <div className="border-t border-gray-400 mb-1" />
       Receive By
        </div>

        <div>
          
          
          <div className="border-t border-gray-400 mb-1" />
          IT Officer
        </div>
        <div>
          <div className="border-t border-gray-400 mb-1" />
          Branch Manager
        </div>
        <div>
          <div className="border-t border-gray-400 mb-1" />
         General Manager
        </div>

          <div>
          <div className="border-t border-gray-400 mb-1" />
     Managing Director
        </div>


      </div>

      <div className="border-t border-gray-300 text-center text-sm py-2">
        {contact}
      </div>
    </div>
  );
};
